import React from 'react';
import type {AppearanceWithDefaults} from '@stripe-internal/embedded-theming';

export const AppearanceWithDefaultsContext = React.createContext<
  AppearanceWithDefaults | undefined
>(undefined);
AppearanceWithDefaultsContext.displayName = 'AppearanceWithDefaultsContext';

export const useAppearanceWithDefaults = ():
  | AppearanceWithDefaults
  | undefined => {
  return React.useContext(AppearanceWithDefaultsContext);
};
